// From #56207
const MIN_HEIGHT = 80
const MIN_WIDTH = 900

export { MIN_HEIGHT, MIN_WIDTH }
